// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__231D0","header":"ReportDetails_header__3YV4m","title":"ReportDetails_title__cylq4","left":"ReportDetails_left__1OA-Z"};